import { BasePage } from 'altus-ui-components';

import useCheetahJobs from 'features/data-exchange/hooks/useCheetahJobs';
import CheetahJobsTable from 'features/data-exchange/components/CheetahJobsTable';
import { CheetahJobSource } from 'features/projects/dashboard/dashboard.constants';
import CheetahJobFilterContainer from 'features/data-exchange/components/CheetahJobFilterContainer';

const filter = {
  isCompleted: false,
  source: CheetahJobSource.CHEETAH,
};

const AvailableCheetahContainer = ({ breadcrumb }) => {
  const { dataState, cheetahJobs, updateCheetahJob, searchCheetahJobs } =
    useCheetahJobs(filter);

  return (
    <BasePage dataState={dataState} title={breadcrumb}>
      <CheetahJobFilterContainer filter={filter} onSubmit={searchCheetahJobs} />
      <CheetahJobsTable
        cheetahJobs={cheetahJobs}
        cheetahJobSource={filter.source}
        updateCheetahJob={updateCheetahJob}
      />
    </BasePage>
  );
};

export default AvailableCheetahContainer;
